import { styled } from "@mui/system";
import MuiListItemButton from "@mui/material/ListItemButton";
import MuiListItemIcon from "@mui/material/ListItemIcon";
import { THEME_COLORS } from "constants/theme";

export const ComponentListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,
  borderRadius: "6px",
  transition: "none",
  "&:hover": {
    backgroundColor: THEME_COLORS[theme.palette?.mode?.toUpperCase()].SELECTED_BG,

    ".MuiListItemIcon-root": {
      backgroundColor: THEME_COLORS[theme.palette?.mode?.toUpperCase()].SELECTED_BG,
    }
  },
  marginRight: "15px"
}));

export const ComponentListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  fontSize: "30px",
  justifyContent: "center",
  minWidth: "50px",
  padding: "8px 10px",
  borderRadius: "6px",
  margin: "0 10px 0 6px",
  backgroundColor: THEME_COLORS[theme.palette?.mode?.toUpperCase()].SECONDARY_BG,
}));
